var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle3, _circle4, _path9, _path10, _path11, _path12, _circle5, _circle6, _path13, _path14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorldwide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.515,
    x2: 440.582,
    y1: 131.515,
    y2: 440.582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.974,
    x2: 202.219,
    xlinkHref: "#lg1",
    y1: 535.746,
    y2: -125.198
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.055,
    x2: 55.988,
    xlinkHref: "#lg1",
    y1: 310.055,
    y2: 55.988
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.277,
    x2: 4.969,
    xlinkHref: "#lg2",
    y1: 348.599,
    y2: 207.078
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.947,
    x2: 494.723,
    xlinkHref: "#lg3",
    y1: 268.277,
    y2: 553.355
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.455,
    x2: 139.921,
    y1: 402.371,
    y2: 237.136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.893,
    x2: 576.668,
    xlinkHref: "#lg3",
    y1: 152.787,
    y2: 437.864
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.494,
    x2: 78.675,
    y1: 173.743,
    y2: 59.924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.214,
    x2: 574.262,
    xlinkHref: "#lg3",
    y1: 276.752,
    y2: 308.427
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.759,
    x2: 602.808,
    xlinkHref: "#lg3",
    y1: 114.496,
    y2: 146.171
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.123,
    x2: 231.829,
    y1: 279.302,
    y2: 305.009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.526,
    x2: 197.564,
    y1: 288.706,
    y2: 270.744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.238,
    x2: 241.52,
    y1: 294.335,
    y2: 243.594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.514,
    x2: 217.626,
    y1: 262.222,
    y2: 262.222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.491,
    x2: 220.736,
    y1: 263.065,
    y2: 260.711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9edf5",
    stopOpacity: 0
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.692,
    x2: 207.486,
    y1: 251.95,
    y2: 233.745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.49,
    x2: 245.695,
    y1: 195.774,
    y2: 240.979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.026,
    x2: 185.44,
    y1: 212.31,
    y2: 180.724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.761,
    x2: 262.737,
    y1: 222.209,
    y2: 132.982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.885,
    x2: 652.395,
    xlinkHref: "#lg2",
    y1: 282,
    y2: -369.899
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_1_)",
    r: 255
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m434.552 120.876c-8.75-6.428-18.028-12.322-27.751-17.676-5.354-9.723-11.249-19.002-17.677-27.752-35.693-48.59-83.327-75.35-134.124-75.35s-98.43 26.76-134.124 75.35c-6.428 8.75-12.323 18.028-17.677 27.752-9.723 5.354-19.001 11.249-27.752 17.677-48.589 35.693-75.349 83.326-75.349 134.123s26.76 98.43 75.35 134.124c8.75 6.428 18.028 12.323 27.752 17.677 5.354 9.723 11.249 19.001 17.677 27.752 35.694 48.59 83.327 75.35 134.124 75.35s98.431-26.76 134.124-75.35c6.428-8.75 12.323-18.028 17.677-27.752 9.723-5.354 19.001-11.249 27.751-17.676 48.59-35.694 75.35-83.327 75.35-134.124s-26.761-98.431-75.351-134.125zm-179.552 377.026c-13.999 0-28.837-20.853-40.567-56.435 13.296 1.564 26.847 2.375 40.567 2.375s27.272-.81 40.568-2.375c-11.731 35.582-26.569 56.435-40.568 56.435zm0-66.061c-15.167 0-30.009-1.027-44.414-2.973-7.994-28.266-13.798-62.197-17.119-99.243 19.885 1.422 40.515 2.154 61.533 2.154s41.648-.733 61.533-2.154c-3.321 37.046-9.125 70.976-17.119 99.243-14.404 1.946-29.247 2.973-44.414 2.973zm0-419.743c13.999 0 28.837 20.853 40.568 56.435-13.296-1.564-26.848-2.375-40.568-2.375s-27.272.811-40.567 2.375c11.73-35.582 26.568-56.435 40.567-56.435zm0 66.061c15.167 0 30.01 1.027 44.414 2.973 7.994 28.267 13.798 62.197 17.119 99.243-19.885-1.422-40.516-2.154-61.533-2.154-21.018 0-41.648.733-61.533 2.154 3.321-37.046 9.125-70.977 17.119-99.243 14.405-1.946 29.247-2.973 44.414-2.973zm-64.78 176.841c0-21.396.771-42.362 2.258-62.521 20.159-1.487 41.126-2.258 62.522-2.258s42.363.771 62.522 2.258c1.487 20.159 2.258 41.126 2.258 62.521 0 21.396-.771 42.362-2.258 62.521-20.159 1.487-41.126 2.258-62.522 2.258s-42.362-.771-62.522-2.258c-1.487-20.159-2.258-41.125-2.258-62.521zm-9.845 61.533c-37.046-3.321-70.977-9.125-99.243-17.119-1.946-14.405-2.973-29.247-2.973-44.414s1.027-30.009 2.973-44.414c28.266-7.994 62.197-13.798 99.243-17.119-1.422 19.885-2.154 40.515-2.154 61.533-.001 21.018.732 41.648 2.154 61.533zm149.251-123.066c37.046 3.321 70.976 9.125 99.243 17.119 1.946 14.405 2.973 29.247 2.973 44.414s-1.027 30.009-2.973 44.414c-28.267 7.994-62.197 13.798-99.243 17.119 1.422-19.885 2.154-40.515 2.154-61.533s-.732-41.648-2.154-61.533zm-.962-12.13c-3.16-36.311-8.668-69.795-16.25-98.174 31.293 5.543 60.229 15.507 85.491 28.934 13.426 25.262 23.391 54.198 28.933 85.49-28.379-7.582-61.863-13.09-98.174-16.25zm-147.328 0c-36.311 3.16-69.795 8.668-98.174 16.25 5.542-31.292 15.507-60.229 28.933-85.49 25.262-13.426 54.198-23.391 85.49-28.933-7.58 28.377-13.088 61.861-16.249 98.173zm-112.803 114.23c-35.582-11.73-56.435-26.568-56.435-40.567s20.853-28.837 56.435-40.567c-1.564 13.296-2.375 26.847-2.375 40.567s.811 27.272 2.375 40.567zm112.803 33.097c3.16 36.311 8.668 69.795 16.25 98.174-31.292-5.542-60.229-15.507-85.49-28.933-13.426-25.262-23.391-54.198-28.933-85.491 28.378 7.581 61.862 13.089 98.173 16.25zm147.328 0c36.311-3.16 69.795-8.668 98.174-16.25-5.542 31.292-15.507 60.228-28.933 85.49-25.262 13.427-54.198 23.391-85.491 28.934 7.582-28.379 13.09-61.863 16.25-98.174zm112.803-114.231c35.582 11.731 56.434 26.568 56.434 40.567s-20.852 28.836-56.434 40.567c1.564-13.295 2.375-26.847 2.375-40.567s-.811-27.272-2.375-40.567zm53.601 13.543c-11.741-10.012-30.353-19.013-55.413-26.714-4.364-27.63-12.089-53.955-22.901-78.066 41.028 26.716 69.562 63.402 78.314 104.78zm-108.263-134.729c-24.111-10.812-50.436-18.537-78.067-22.901-7.701-25.06-16.702-43.673-26.714-55.414 41.379 8.752 78.065 37.286 104.781 78.315zm-158.829-78.316c-10.012 11.741-19.013 30.354-26.715 55.414-27.63 4.364-53.955 12.089-78.066 22.901 26.717-41.028 63.402-69.562 104.781-78.315zm-134.73 108.264c-10.812 24.111-18.537 50.436-22.901 78.066-25.06 7.701-43.673 16.702-55.414 26.714 8.753-41.377 37.287-78.063 78.315-104.78zm-78.315 158.829c11.741 10.012 30.354 19.013 55.414 26.715 4.364 27.63 12.089 53.955 22.901 78.066-41.028-26.717-69.562-63.402-78.315-104.781zm108.264 134.73c24.111 10.812 50.436 18.537 78.066 22.901 7.702 25.06 16.702 43.673 26.715 55.414-41.379-8.753-78.064-37.287-104.781-78.315zm158.829 78.315c10.013-11.741 19.013-30.354 26.714-55.414 27.631-4.364 53.956-12.089 78.067-22.901-26.716 41.028-63.402 69.562-104.781 78.315zm134.73-108.265c10.812-24.111 18.537-50.435 22.901-78.066 25.06-7.701 43.672-16.702 55.413-26.714-8.752 41.378-37.286 78.064-78.314 104.78z",
    fill: "url(#SVGID_2_)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 255,
    fill: "url(#SVGID_3_)",
    r: 227.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m460.195 406.399-219.515-219.514c-6.399-7.9-16.173-12.954-27.131-12.954-19.276 0-34.903 15.626-34.903 34.903 0 10.947 5.046 20.708 12.934 27.104 1.541 1.905 16.993 17.253 17.774 18.049v13.348c-8.945 1.927-15.653 9.873-15.653 19.395 0 6.805 3.429 12.807 8.649 16.382l175.426 175.426c32.425-17.849 60.545-42.542 82.419-72.139z",
    fill: "url(#SVGID_4_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m231.172 265.619 9.872 9.871c3.611 3.611 5.639 8.508 5.639 13.614 0 10.633 8.62 19.253 19.253 19.253 11.089 0 20.079 8.989 20.079 20.078 0 14.419-3.008 28.679-8.833 41.869l-35.542 80.488c-4.865 11.018-19.279 13.712-27.796 5.195-12.413-12.413-19.387-29.249-19.387-46.804v-9.362c0-24.407-9.696-47.815-26.954-65.073l-1.052-1.052c-16.242-16.241-25.366-38.27-25.366-61.239v-3.355c0-15.933 12.916-28.849 28.849-28.849 22.968 0 44.997 9.125 61.238 25.366z",
    fill: "url(#SVGID_5_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m265.935 308.358c-10.633 0-19.253-8.62-19.253-19.253 0-5.106-2.028-10.003-5.639-13.614l-9.872-9.871c-8.481-8.481-18.548-14.999-29.495-19.313 3.812 3.826 7.316 7.311 7.677 7.68v13.348c-8.945 1.927-15.653 9.873-15.653 19.395 0 6.805 3.429 12.807 8.649 16.382l72.492 72.492 2.339-5.298c5.824-13.19 8.833-27.45 8.833-41.869.001-11.09-8.989-20.079-20.078-20.079z",
    fill: "url(#SVGID_6_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m167.298 15.489c-63.844 23.386-115.727 71.573-143.99 132.892-3.35 7.267-5.008 15.2-5.008 23.201 0 14.905 5.921 29.199 16.46 39.738l5.212 5.212c23.355 23.355 55.032 36.476 88.061 36.476 4.934 0 8.934-4 8.934-8.934 0-4.934-4-8.934-8.934-8.934h-27.464c-12.667 0-22.935-10.268-22.935-22.935 0-12.667 10.269-22.935 22.935-22.935h21.451c25.721 0 50.388-10.218 68.576-28.405l33.12-33.12c7.212-7.212 16.994-11.264 27.193-11.264 14.755 0 28.209-8.442 34.627-21.727 7.867-16.282-3.996-35.188-22.079-35.188h-42.733c-12.564 0-22.749-10.185-22.749-22.749 0-15.856-15.789-26.781-30.677-21.328z",
    fill: "url(#SVGID_7_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m263.457 59.565h-42.733c-12.564 0-22.749-10.185-22.749-22.749 0-.747-.046-1.478-.114-2.202-83.307 21.538-148.109 89.063-165.719 173.879.842.966 1.706 1.915 2.617 2.827l5.212 5.212c23.355 23.355 55.032 36.476 88.061 36.476 4.934 0 8.934-4 8.934-8.934 0-4.934-4-8.934-8.934-8.934h-27.464c-12.667 0-22.935-10.269-22.935-22.935 0-12.667 10.269-22.935 22.935-22.935h21.451c25.721 0 50.388-10.218 68.576-28.405l33.12-33.12c7.212-7.212 16.994-11.264 27.193-11.264 14.755 0 28.208-8.442 34.627-21.727 7.867-16.283-3.995-35.189-22.078-35.189z",
    fill: "url(#SVGID_8_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m504.064 200.057c-3.522-16.035-17.859-27.377-34.277-27.377h-35.947-19.215c-32.659 0-59.135 26.476-59.135 59.135v7.195c0 28.686 23.255 51.94 51.941 51.94 14.586 0 26.409 11.824 26.409 26.41v68.964c0 17.971 23.334 25.13 33.321 10.189 20.755-31.049 34.874-66.914 40.329-105.563 1.65-11.74 2.51-23.75 2.51-35.95 0-18.866-2.05-37.248-5.936-54.943z",
    fill: "url(#SVGID_9_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m482.62 139.93h-76.17c-13.625 0-24.67-11.045-24.67-24.67 0-13.625 11.045-24.67 24.67-24.67h43.48c12.71 15.05 23.71 31.6 32.69 49.34z",
    fill: "url(#SVGID_10_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.549,
    cy: 286.728,
    fill: "url(#SVGID_11_)",
    r: 19.848
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.549,
    cy: 286.728,
    fill: "url(#SVGID_12_)",
    r: 16.565
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m222.428 268.974c1.339 2.672 2.093 5.687 2.093 8.879 0 10.962-8.886 19.848-19.848 19.848-3.192 0-6.207-.755-8.879-2.093 3.259 6.504 9.985 10.969 17.755 10.969 10.962 0 19.848-8.886 19.848-19.848 0-7.771-4.465-14.497-10.969-17.755z",
    fill: "url(#SVGID_13_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m213.549 288.315c-2.317 0-4.195-1.878-4.195-4.195v-47.99h8.391v47.99c-.001 2.317-1.879 4.195-4.196 4.195z",
    fill: "url(#SVGID_14_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m214.875 288.097c1.666-.555 2.869-2.125 2.869-3.978v-47.99h-5.738v47.99c0 1.854 1.203 3.423 2.869 3.978z",
    fill: "url(#SVGID_15_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m209.354 243.486 8.39 8.39v-15.746h-8.39z",
    fill: "url(#SVGID_16_)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.549,
    cy: 208.833,
    fill: "url(#SVGID_17_)",
    r: 34.903
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.549,
    cy: 208.833,
    fill: "url(#SVGID_18_)",
    r: 29.129
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m229.162 177.611c2.354 4.698 3.681 10 3.681 15.613 0 19.276-15.626 34.903-34.903 34.903-5.613 0-10.915-1.327-15.613-3.681 5.73 11.437 17.558 19.29 31.222 19.29 19.276 0 34.903-15.626 34.903-34.903 0-13.663-7.853-25.491-19.29-31.222z",
    fill: "url(#SVGID_19_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m369.069 26.893c17.198 34.325 26.893 73.062 26.893 114.069 0 140.833-114.167 255-255 255-41.007 0-79.744-9.694-114.069-26.893 41.868 83.561 128.281 140.931 228.107 140.931 140.833 0 255-114.167 255-255 0-99.826-57.371-186.239-140.931-228.107z",
    fill: "url(#SVGID_20_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldwide);
export default __webpack_public_path__ + "static/media/worldwide.846bd31c.svg";
export { ForwardRef as ReactComponent };